import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

const PHOTOS = [
  { src: "/wins/win-242-live.webp", alt: "Schedina in corso: 4 partite Over 12.5 corner, quota 242" },
  { src: "/wins/win-242-final.webp", alt: "Schedina conclusa: tutte e 4 le selezioni Over 12.5 corner vinte" },
];

export function WinShowcase() {
  const [open, setOpen] = useState(null);
  return (
    <section className="surface-raised fade-up relative overflow-hidden p-6 sm:p-8 border-t-2 border-[#39FF14]" data-testid="win-showcase">
      <div className="grid md:grid-cols-[1.1fr_1fr] gap-8 items-center">
        <div>
          <div className="label text-[#39FF14] text-[10px]">Vincita reale · mista corner Over 12.5</div>
          <h2 className="heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mt-3 leading-[0.95]" data-testid="win-showcase-title">
            Quota <span className="text-[#39FF14]">242</span> vincita mostruosa con la nostra app 💪
          </h2>
          <p className="text-[#A1A1AA] mt-3 text-sm">Sì, avete letto bene: <b className="text-white">242</b>.</p>
          <div className="mt-6 inline-flex flex-wrap items-end gap-x-4 gap-y-1" data-testid="win-showcase-amount">
            <span className="mono text-sm text-[#A1A1AA]">5,00 € giocati</span>
            <span className="heading text-4xl sm:text-5xl font-black text-[#FFCC00] underline decoration-[#39FF14] decoration-4 underline-offset-8">
              1.211,46 € vinti
            </span>
          </div>
          <p className="text-[11px] text-[#71717A] mt-6">4 partite di Champions League, tutte Over 12.5 corner. Il gioco è vietato ai minori e può causare dipendenza.</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {PHOTOS.map((p, i) => (
            <button key={p.src} onClick={() => setOpen(p)} data-testid={`win-photo-${i}`}
              className="border border-[#27272A] hover:border-[#39FF14] transition-colors overflow-hidden aspect-[9/14]">
              <img src={p.src} alt={p.alt} loading="lazy" className="w-full h-full object-cover object-top" />
            </button>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-md p-0 bg-black border-[#27272A] max-h-[90vh] overflow-y-auto" data-testid="win-photo-dialog">
          <DialogTitle className="sr-only">{open?.alt}</DialogTitle>
          {open && <img src={open.src} alt={open.alt} className="w-full" />}
        </DialogContent>
      </Dialog>
    </section>
  );
}
